import React from 'react';
import './OrdersExpander.scss';
import { Collapse } from 'react-collapse';
import { Scrollbars } from 'react-custom-scrollbars';
import { gettext } from '../../i18n/service.js';

global.globalWindowHeight = document.documentElement.clientHeight * 0.8 / 2;
export function OrdersExpander(props) {
    const { isOpen, orders, toggle, title, children, orderHeight } = props;
    console.log(orderHeight)
    const text = orders.length + ' ' + title;
    const icon = isOpen ? 'chevron-down' : 'menu-right';
    const orderNumber = Math.floor(globalWindowHeight / orderHeight);
    return (
        <div className="sidebar-orders-expander" id="sidebar-orders-expander">
            <div className="expand-button" onClick={toggle}>
                <div className="media-left">
                {
                    title.toLowerCase() === gettext('ORDER.NEW-ORDERS').toLowerCase() ? <img src="./new-orders-icon.svg"/>  :
                    title.toLowerCase() === gettext('ORDER.IN-PROGRESS').toLowerCase() ? <img src="./in-progress-orders-icon.svg"/> :
                    <img src="./completed-orders-icon.svg"/>
                }
                </div>
                <div className="media-body">
                    {text}
                </div>
                <div className="media-right">
                    <span className={"glyphicon glyphicon-" + icon} />
                </div>
            </div>
            {orders.length > orderNumber ? renderScrolled(children, isOpen, globalWindowHeight) : renderPlain(children, isOpen)}
        </div>
    );
}

function renderPlain(children, isOpen) {
    return (
        <Collapse isOpened={isOpen}>
            {children}
        </Collapse>
    );
}

function renderScrolled(children, isOpen, actualHeight) {
    return (
        <Collapse isOpened={isOpen} fixedHeight={actualHeight}>
            <Scrollbars style={{ height: actualHeight + 'px' }} trackHorizontal={false}>
                {children}
            </Scrollbars>
        </Collapse>
    );
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/OrdersExpander.js